/* eslint-disable @typescript-eslint/naming-convention */
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { useCallback } from 'react';

import { TextInput, ITextInputProps } from 'UIPackage/MainModule/components/TextInput';

type Value = ITextInputProps['value'];
type ITextInputFieldProps = ITextInputProps &
  FieldProps<Value, FieldRenderProps<Value>> & {
    link: string;
  };

export const TextInputFieldAsLink = (props: ITextInputFieldProps) => {
  const {
    afterSubmit,
    allowNull,
    beforeSubmit,
    data,
    defaultValue,
    format,
    formatOnBlur,
    initialValue,
    isEqual,
    multiple,
    name,
    parse,
    subscription,
    type,
    validate,
    validateFields,
    value,
    link,
    ...componentProps
  } = props;

  const onClickLinkVisit = useCallback(() => {
    window.open(link, '_blank');
  }, [link]);

  return (
    <Field
      afterSubmit={afterSubmit}
      allowNull={allowNull}
      beforeSubmit={beforeSubmit}
      data={data}
      defaultValue={defaultValue}
      format={format}
      formatOnBlur={formatOnBlur}
      initialValue={initialValue}
      isEqual={isEqual}
      multiple={multiple}
      name={name}
      parse={parse}
      subscription={subscription}
      type={type}
      validate={validate}
      validateFields={validateFields}
      value={value}
    >
      {({ input, meta }) => {
        const { ...restComponentProps } = componentProps;

        const error =
          (meta.touched && restComponentProps.error) || (meta.touched && meta.error) ? meta.error : undefined;
        const errorOnSubmit = meta.error && (meta.dirty || meta.submitFailed) && meta.touched && meta.error;

        return (
          <TextInput
            {...restComponentProps}
            {...input}
            onClick={onClickLinkVisit}
            disabled={true}
            isLink={true}
            error={restComponentProps.validateOnSubmit ? errorOnSubmit : error}
          />
        );
      }}
    </Field>
  );
};
